__turbopack_context__.v({
  "bgImageDesktop": "aS86fa_bgImageDesktop",
  "bgImageMobile": "aS86fa_bgImageMobile",
  "parallaxBackgroundImg": "aS86fa_parallaxBackgroundImg",
});
